import React from 'react';
import ButtonComponent from './ButtonMC';
import CustomIcon from './CustomIconMC';
import IconMC from './IconMC';

/**
 * ButtonSelectorMC component renders a button with an optional icon and a checkmark icon if selected.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.text - The text to display on the button.
 * @param {function} props.onClick - The function to call when the button is clicked.
 * @param {React.Component} props.icon - The icon component to display on the button.
 * @param {boolean} [props.isSelected=false] - Whether the button is selected.
 * @param {string} [props.className=""] - Additional class names to apply to the wrapper div.
 * @param {'left'|'right'} [props.iconPosition="left"] - The position of the icon relative to the text.
 *
 * @returns {JSX.Element} The rendered ButtonSelectorMC component.
 */
const ButtonSelectorMC = ({
  text,
  onClick,
  icon: Icon,
  isSelected = false,
  className = "",
  iconPosition = "left"
}) => (
  <div className={`tw-relative tw-wrapper ${className}`}>
    <ButtonComponent
      text={text}
      icon={Icon}
      className={`!tw-bg-transparent !tw-py-4 tw-w-full tw-text-sm ${isSelected ? '!tw-border-blue-500' : ''}`}
      onClick={onClick}
      variant="GRAY"
      iconPosition={iconPosition}
      outlined
    />
    {isSelected && (
      <IconMC
        name="checkmark-circle-2-fill"
        className="tw-text-blue-500 tw-absolute tw-top-2 tw-right-2"
        size="base"
      />
    )}
  </div>
);

export default ButtonSelectorMC;
